import type { FNode, FNodeChild } from './dom/types'

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- JSX factory: type must accept any component or tag; props are heterogeneous across all components
export function jsx(type: any, props: Record<string, unknown>, key?: unknown): FNode {
    const { children, key: propsKey, ...otherProps } = props || {}
    // Use explicit key argument if provided, otherwise use key from props
    const finalKey = key !== undefined ? key : propsKey
    return {
        type,
        props: otherProps,
        children: Array.isArray(children) ? children : (children != null ? [children as FNodeChild] : []),
        key: finalKey
    }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- see jsx above
export function jsxs(type: any, props: Record<string, unknown>, key?: unknown): FNode {
    return jsx(type, props, key)
}

// Development version (same as jsx for our purposes)
// eslint-disable-next-line @typescript-eslint/no-explicit-any -- see jsx above
export function jsxDEV(type: any, props: Record<string, unknown>, key?: unknown): FNode {
    return jsx(type, props, key)
}

export function Fragment(props: Record<string, unknown>): FNodeChild {
    return props.children as FNodeChild
}

// eslint-disable-next-line @typescript-eslint/no-namespace -- JSX namespace is required by TypeScript's JSX type system; cannot be replaced with module syntax
export namespace JSX {
    export interface IntrinsicElements {
        [elemName: string]: Record<string, unknown>
    }
    export type Element = FNode | FNodeChild
    export interface ElementChildrenAttribute {
        // eslint-disable-next-line @typescript-eslint/no-empty-object-type -- `children: {}` is the TypeScript-idiomatic way to declare the children prop in JSX ElementChildrenAttribute
        children: {}
    }
}
